<template>
  <BaseModal :is-open="showModal" :title description="" size="small" @close="close">
    <slot />
    <p v-if="error" class="server-error" role="alert">{{ error }}</p>
    <template #actions>
      <BaseButton variant="ghost" color="grey" @click="close">Cancel</BaseButton>
      <BaseButton :disabled="hold" @click="doit"> Delete </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import BaseButton from "./BaseButton.vue";
import BaseModal from "./BaseModal.vue";

export default {
  name: "DeleteModalLegacy",
  components: { BaseModal, BaseButton },
  props: {
    title: { type: String, required: true },
  },
  emits: ["delete"],
  data() {
    return {
      showModal: false,
      hold: false,
      obj: null,
      error: "",
    };
  },
  methods: {
    show(obj) {
      this.showModal = true;
      this.hold = false;
      this.obj = obj;
      this.error = "";
      return obj;
    },
    doit() {
      this.hold = true;
      this.$emit("delete", this.obj);
    },
    fail(message) {
      this.hold = false;
      this.error = message;
    },
    close() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/colors" as c;

.server-error {
  color: c.$red;
  font-size: 0.875rem;
  margin-top: 12px;
}
</style>
